import { LAST_ROW_OFFSET } from '../constants';
import { RowType } from '../../types/RowType';

export function markLastRow(rows: RowType[]): RowType[] {
  if (rows.length) {
    const lastRowIndex = rows.length - 1;
    rows[lastRowIndex].rowData = {
      ...rows[lastRowIndex].rowData,
      size: rows[lastRowIndex].rowData.size + LAST_ROW_OFFSET,
      isLast: true,
    };
  }

  return rows;
}
